import { getCreativityOptions } from '../../constants/clients/registry';
import { CreativityType } from '../../types/banner';
import { useClientId } from '../use-client-id';

export const useTemplateInfo = (creativityType?: CreativityType) => {
  const clientId = useClientId();

  if (!creativityType) {
    return {
      title: '',
      previewVideo: undefined,
      videoVariants: {},
      thumbnail: undefined
    };
  }

  const creativityOptions = getCreativityOptions(clientId);
  const template = creativityOptions.find(t => t.id === creativityType);

  const videoVariants: Record<string, string> = Object.entries(template || {})
    .filter(([key, value]) => key.startsWith('video_') && typeof value === 'string')
    .reduce(
      (acc, [key, value]) => {
        const resolution = key.replace('video_', '');
        acc[resolution] = value;
        return acc;
      },
      {} as Record<string, string>
    );

  return {
    title: template?.title || creativityType,
    previewVideo: template?.video as string | undefined,
    videoVariants,
    thumbnail: template?.image as string | undefined
  };
};
